// extracted by mini-css-extract-plugin
export default {"incorrectBirth":"SignUpIncorrectBirthStep_incorrectBirth__u9BPzIJC","warning":"SignUpIncorrectBirthStep_warning__HCa6rdbz","back":"SignUpIncorrectBirthStep_back__aPCcI47L"};